/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, none } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SystemVarsAccountsXeroSyncDto, SystemVarsAccountsXeroSyncMapper, XeroSyncProgressDto } from '../system-vars';
import { XeroSyncInfoDto } from './xero-sync.dto';
import { XeroSyncInfoMapper } from './xero-sync.mapper';

@Injectable()
export class XeroSyncRestService extends AbstractRestService {
  getInfo(): Observable<XeroSyncInfoDto> {
    return this.httpGet(`${this.bp}/accounting/sync-info`, XeroSyncInfoMapper);
  }

  sync(info: SystemVarsAccountsXeroSyncDto): Observable<void> {
    return this.httpPost(`${this.bp}/accounting/sync`, info, SystemVarsAccountsXeroSyncMapper, none());
  }

  getSyncStatus(): Observable<XeroSyncProgressDto> {
    return this.httpGet(`${this.bp}/accounting/check-sync-progress`, identity());
  }

}
